var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-overlay',{attrs:{"z-index":"999"},model:{value:(_vm.loading),callback:function ($$v) {_vm.loading=$$v},expression:"loading"}},[_c('v-progress-circular',{attrs:{"size":80,"width":"5","color":"white","indeterminate":""}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }